import type { TextComposerAuthoringState } from "@/features/TextComposerV2/editor/authoringState";
import type { Frame } from "@/types/dragon-tiles";

import {
  findFirstTextComposerSourceVariant,
  parseTextComposerAuthoringSeed,
} from "@/features/TextComposerV2/frame/framePersistence";

/** Parse a tile's text-composer authoring state (empty when absent). */
export function parseFrameSeed(
  frame: Frame | undefined,
): TextComposerAuthoringState {
  if (!frame) return {};
  const sourceVariant = findFirstTextComposerSourceVariant(frame);
  if (!sourceVariant) return {};
  return parseTextComposerAuthoringSeed(sourceVariant.content_json);
}
